import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BaseDisplayModel } from '@common/models/baseDisplayModel';
import { positiveNumberValidator } from '@common/validators/positive-number-validator';
import { requiredValidator } from '@common/validators/required-validator';

export class EditVehicleModalModel extends BaseDisplayModel {
    public serviceRequesId = null;
    public cargoManifestId = null;
    public adrId: string;
    public linkedUnitVehicleId = null;

    constructor(data = null) {
        super();
        if (data) {
            Object.assign(this, data);
        }
    }

    generateGroup() {
        const form = new UntypedFormGroup({
            id: new UntypedFormControl({ value: null, disabled: true }),
            vehicleTypeId: new UntypedFormControl({ value: null, disabled: false }, [requiredValidator()]),
            vehicleBrandId: new UntypedFormControl({ value: null, disabled: false }),
            vehicleNumber: new UntypedFormControl({ value: null, disabled: false }),
            licencePlate: new UntypedFormControl({ value: null, disabled: false }),
            producedYear: new UntypedFormControl({ value: null, disabled: false }),
            driverName: new UntypedFormControl({ value: null, disabled: false }, [requiredValidator()]),
            secondDriver: new UntypedFormControl({ value: null, disabled: false }),
            owner: new UntypedFormControl({ value: null, disabled: false }),
            receiver: new UntypedFormControl({ value: null, disabled: false }),
            consignee: new UntypedFormControl({ value: null, disabled: false }),
            originId: new UntypedFormControl({ value: null, disabled: false }),
            portOfLoadingId: new UntypedFormControl({ value: null, disabled: false }, [requiredValidator()]),
            destinationCountryId: new UntypedFormControl({ value: null, disabled: false }),
            portOfDischargeId: new UntypedFormControl({ value: null, disabled: false }, [requiredValidator()]),
            tir: new UntypedFormControl({ value: null, disabled: false }),
            length: new UntypedFormControl({ value: null, disabled: false }, [
                requiredValidator(),
                positiveNumberValidator()
            ]),
            compositionLength: new UntypedFormControl({ value: null, disabled: false }, [
                requiredValidator(),
                positiveNumberValidator()
            ]),
            taraWeight: new UntypedFormControl({ value: null, disabled: false }, [positiveNumberValidator()]),
            hasCargo: new UntypedFormControl({ value: null, disabled: false }),
            cargoNetWeight: new UntypedFormControl({ value: null, disabled: true }),
            cargoGrossWeight: new UntypedFormControl({ value: null, disabled: false }, [
                requiredValidator(),
                positiveNumberValidator()
            ]),
            particulars: new UntypedFormControl({ value: null, disabled: false }),
            hasDangerousCargo: new UntypedFormControl({ value: null, disabled: true }),
            imdg: new UntypedFormControl({ value: null, disabled: false }),
            unNumber: new UntypedFormControl({ value: null, disabled: false }),
            imdgPackingGroup: new UntypedFormControl({ value: null, disabled: false }),
            adrId: new UntypedFormControl({ value: null, disabled: false }),
            technicalName: new UntypedFormControl({ value: null, disabled: false }),
            dgContact: new UntypedFormControl({ value: null, disabled: false }),
            containerNumberFirst: new UntypedFormControl({ value: null, disabled: false }),
            containerNumberSecond: new UntypedFormControl({ value: null, disabled: false }),
            newVehicle: new UntypedFormControl({ value: null, disabled: false }),
            remark: new UntypedFormControl({ value: null, disabled: false }),
            linkedUnitVehicleId: new UntypedFormControl({ value: null, disabled: false }),
            trailers: new UntypedFormArray([])
        });

        form.patchValue(this);
        return form;
    }
}
